import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import ReactMarkdown from 'react-markdown'
import DisplayProductCard from '../../common/display-product-card'
import DisplayProductCardSkeleton from '../../common/display-product-card-skeleton'
import * as productActions from '../../store/products'
import TopNavigationAppShell from '../../common/top-navigation-app-shell'
import FooterComponent from '../../common/footer'
import Y from '../../y18n'

const styles = theme => ({
  appBar: {
    position: 'relative'
  },
  icon: {
    marginRight: theme.spacing.unit * 2
  },
  heroUnit: {
    backgroundColor: '#3a3a3a'
  },
  heroContent: {
    maxWidth: 800,
    minHeight: 450,
    margin: '0 auto',
    padding: `${theme.spacing.unit * 8}px 5px ${theme.spacing.unit * 6}px`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  heroButtons: {
    marginTop: theme.spacing.unit * 4
  },
  heroButton: {
    border: '1px solid #34740e',
    '-webkit-border-radius': '0px',
    '-moz-border-radius': '0px',
    borderRadius: '0px',
    fontSize: '18px',
    fontFamily: 'helvetica, sans-serif',
    padding: '10px 10px 10px 10px',
    textDecoration: 'none',
    display: 'inline-block',
    textShadow: '-1px -1px 0 rgba(0,0,0,0.3)',
    fontWeight: 'bold',
    color: '#FFFFFF',
    backgroundColor: '#4BA614; background-image: -webkit-gradient(linear, left top, left bottom, from(#4BA614), to(#008c00))',
    backgroundImage: 'linear-gradient(to bottom, #4BA614, #008c00);filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=#4BA614, endColorstr=#008c00)',
    '&:hover': {
      border: '1px solid #224b09',
      backgroundColor: '#36780f; background-image: -webkit-gradient(linear, left top, left bottom, from(#36780f), to(#005900))',
      backgroundImage: 'linear-gradient(to bottom, #36780f, #005900);filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=#36780f, endColorstr=#005900)'
    }
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1200 + theme.spacing.unit * 3 * 2)]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      marginRight: 0
    }
  },
  cardGrid: {
    padding: `${theme.spacing.unit * 8}px 0`
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  cardHeader: {
    textAlign: 'center'
  },
  cardMedia: {
    paddingTop: '56.25%' // 16:9
  },
  cardContent: {
    flexGrow: 1
  },
  imageContainer: {
    marginLeft: '40px',
    marginRight: '40px',
    minHeight: '280px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '20px',
      marginRight: '20px'
    }
  },
  footer: {
    marginTop: theme.spacing.unit * 8,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit * 6}px 0`,
    width: '100%',
    backgroundColor: '#fff'
  },
  col: {
    padding: 0,
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  colInside: {
    flex: '1',
    display: 'flex',
    margin: '0 10px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      margin: 0
    }
  },
  number: {
    color: `${theme.palette.primary.main}`,
    textAlign: 'center',
    font: '52px Arial, sanf serif',
    '&:hover': {
      color: `${theme.palette.primary.dark}`
    }
  },
  themeLink: {
    color: `${theme.palette.primary.main}`,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: `${theme.palette.primary.dark}`
    }
  },
  whiteSection: {
    backgroundColor: '#fff',
    width: '100%',
    marginTop: '80px',
    borderTop: '1px solid #e6e1e1',
    borderBottom: '1px solid #e6e1e1'
  },
  content: {
    maxWidth: '1200px',
    margin: 'auto',
    padding: '16px 24px',
    [theme.breakpoints.down('xs')]: {
      padding: '8px 16px'
    }
  },
  narrowContent: {
    maxWidth: '1000px',
    margin: 'auto',
    padding: '24px 24px',
    [theme.breakpoints.down('xs')]: {
      padding: '16px 16px'
    }
  },
  flexRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  flexItemLeftSmall: {
    flex: '1',
    maxWidth: '250px',
    marginTop: '10px',
    marginRight: '5px',
    order: 1,
    textAlign: 'center',
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      marginRight: '0',
      minWidth: '100%',
      order: 2,
      marginTop: '40px'
    }
  },
  flexItemLeft: {
    flex: '1',
    marginTop: '10px',
    marginRight: '5px',
    textAlign: 'center',
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      marginRight: '0',
      minWidth: '100%',
      marginTop: '40px'
    }
  },
  flexItemRight: {
    flex: '1',
    marginTop: '10px',
    marginLeft: '5px',
    paddingLeft: '20px',
    order: 2,
    textAlign: 'center',
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0',
      minWidth: '100%',
      paddingLeft: '0',
      order: 1
    }
  },
  flexItemRightSmall: {
    flex: '1',
    maxWidth: '250px',
    marginTop: '10px',
    marginLeft: '5px',
    paddingLeft: '20px',
    textAlign: 'center',
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0',
      minWidth: '100%',
      paddingLeft: '0'
    }
  },
  displayProductsGrid: {
    paddingTop: 50,
    minHeight: '100%',
    marginTop: '-90px',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      marginTop: '-20px'
    }
  }
})

const mapStateToProps = state => ({
  products: state.products,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  productActions: bindActionCreators(productActions, dispatch)
})

class HomePage extends Component {
  componentDidMount () {
    this.props.productActions.getDisplayProducts(this.props.locales.country)
  }

  render () {
    const { classes } = this.props
    return (
      <TopNavigationAppShell
        content={
          <React.Fragment>
            <div id={'hero'} style={{ marginTop: '-64px' }}>
              {this.renderHeroSection()}
            </div>
            <div className={classes.layout}>
              {this.renderDisplayProducts()}
            </div>
            <div className={classes.whiteSection}>
              {this.renderWhat()}
            </div>
            <div className={classes.whiteSection} style={{ marginTop: '80px' }}>
              {this.renderWhy()}
            </div>
            <div className={classes.whiteSection} style={{ marginTop: '80px' }}>
              {this.renderSteps()}
            </div>
            <FooterComponent country={this.props.locales.country} />
          </React.Fragment>
        }
        startPage
      />
    )
  }

  renderHeroSection () {
    const { classes, locales } = this.props
    return (
      <div className='object-fit-container cover'>
        <img
          src='images/bg1900w.jpg'
          srcSet='images/bg450w.jpg 450w,
                  images/bg900w.jpg 900w,
                  images/bg1400w.jpg 1400w,
                  images/bg1900w.jpg 1900w,
                  images/bg2050w.jpg 2050w,
                  images/bg4000w.jpg 4000w,'
          alt='deer'
        />
        <div className={classes.heroContent}>
          <span
            style={{
              color: '#fff',
              textAlign: 'center',
              fontSize: '42px',
              fontWeight: 'bold',
              marginTop: '40px',
              textShadow: '-1px -1px 0 rgba(0,0,0,0.3)'
            }}
          >
            {Y`Hylte SIM is a data customized SIM card`}
          </span>
          <span
            style={{
              color: '#fff',
              textAlign: 'center',
              fontSize: '18px',
              marginTop: '10px'
            }}
          >
            {Y`It is suitable for surveillance cameras, cameras and other IoT devices that need internet access`}
          </span>
          <div className={classes.heroButtons}>
            <Grid container spacing={16} justify='center'>
              <Grid item>
                <Link to={'/register'}>
                  <Button variant='contained' color='primary' className={classes.heroButton}>
                    {Y`Register account`}
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    )
  }

  renderDisplayProducts () {
    const { classes, products } = this.props
    return (
      <div>
        <Grid container spacing={40} className={classes.displayProductsGrid}>
          {!products.displayItems || !products.displayItems.length > 0
            ? <DisplayProductCardSkeleton cards={3} mdSize={4} />
            : products.displayItems.map((product, index) => (
              <Grid item key={index} xs={12} sm={12} md={4} className={classes.col}>
                <DisplayProductCard displayProduct={product} country={this.props.locales.country} language={this.props.locales.language} />
              </Grid>
              ))}
        </Grid>
        <div style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}>
          <Typography variant='title'>
            {Y`You find more products in the`}
            {' '}
            <a
              href='https://www.hylte-lantman.com/hyltesim/kop-hyltesim'
              rel='noopener noreferrer'
              target='_blank'
              className={classes.themeLink}
            >
              {Y`webshop`}
            </a>
          </Typography>
        </div>
      </div>
    )
  }

  renderWhat () {
    const { classes, locales } = this.props
    return (
      <div className={classes.narrowContent}>
        <div className={classes.flexRow}>
          <div className={classes.flexItemLeftSmall}>
            <img
              src='/images/hylte_nyteckning.png'
              alt='logo'
              style={{ minWidth: '200px', width: '100%', maxWidth: '250px' }}
            />
          </div>
          <div className={classes.flexItemRight}>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <span style={{ fontWeight: 'bold', fontSize: '22px' }}>
                {Y`What is Hylte SIM?`}
              </span>
            </div>
            <Typography variant='subheading' align='center' style={{ marginTop: '20px' }}>
              <div style={{ display: 'block' }}>
                <ReactMarkdown
                  source={Y`Hylte SIM is a data customized SIM card, suitable for surveillance cameras, cameras and other IoT devices that require internet access. Hylte SIM uses Roaming, which means that the product connects to the mobile network available where the product is placed. Works with all operators in Sweden as well as throughout the Nordic region.`
                  }
                />
              </div>
              <p>
                {Y`All at the same fixed cost!`}
              </p>
              <p>
                {Y`Hylte SIM is delivered as standard Mini U-SIM that fits most types of surveillance cameras.`}
              </p>
            </Typography>
          </div>
        </div>
      </div>
    )
  }

  renderWhy () {
    const { classes, locales } = this.props
    return (
      <div className={classes.narrowContent}>
        <div className={classes.flexRow}>
          <div className={classes.flexItemLeft}>
            <div style={{ width: '100%', textAlign: 'center' }}>
              <span style={{ fontWeight: 'bold', fontSize: '22px' }}>
                {Y`Why should I choose Hylte SIM?`}
              </span>
            </div>
            <Typography variant='subheading' align='center' style={{ marginTop: '20px' }}>
              <p>
                {Y`Because the technology is based on what is known as M2M technology, all data traffic gets top priority in the mobile network.`}
              </p>
              <p>
                {Y`Thanks to Roaming, the product itself selects the operator and mobile network available on the site. Works throughout the Nordic region. So it does not matter if the product is used in Finland, Denmark, Norway or Sweden. The product will work immediately without changing settings if you move the product across borders.`}
              </p>
              <p>
                { Y`Hylte SIM becomes more cost effective as subscriptions are more suited to products that only need limited data on the Internet.`}
              </p>
            </Typography>
          </div>
          <div className={classes.flexItemRightSmall}>
            <img
              src='/images/nordic.png'
              alt='nordic countries'
              style={{ minWidth: '200px', width: '100%', maxWidth: '200px' }}
            />
          </div>
        </div>
      </div>
    )
  }

  renderSteps () {
    const { classes } = this.props
    const steps = [
      {
        nr: '1',
        description: 'Click REGISTER ACCOUNT. Fill out the form with your information and then click REGISTER'
      },
      {
        nr: '2',
        description: 'Click the link in the E-mail we sent to the E-mailaddress you provided to choose a password'
      },
      {
        nr: '3',
        description: 'Once you have chosen a password you will automatically be logged in and redirected to MY SUBSCRIPTIONS'
      },
      {
        nr: '4',
        description: 'Click ADD SUBSCRIPTION and enter a name for the subscription, your IMSI number and your verification code. Then click CREATE SUBSCRIPTION'
      }
    ]
    return (
      <div className={classes.content}>
        <div style={{ width: '100%', textAlign: 'center', marginTop: '10px' }}>
          <span style={{ fontWeight: 'bold', fontSize: '22px' }}>
            {Y`Get started in 4 easy steps!`}
          </span>
          <Typography variant='subheading'>
            {Y`If you have problem understanding any of the steps we have uploaded a`}
            {' '}
            {' '}
            <a
              href='https://www.youtube.com/watch?v=sPMY9StKg7s'
              target='_blank'
              rel='noopener noreferrer'
              className={classes.themeLink}
            >
              {Y`video on YouTube`}
            </a> {Y`explaining every step more thoroughly`}
          </Typography>
        </div>
        <Grid container spacing={8} style={{ paddingTop: 20, minHeight: '100%' }}>
          {steps.map(step => (
            <Grid item key={step.nr} xs={12} sm={6} md={3} className={classes.col}>
              <div className={classes.colInside} style={{ minWidth: '250px', padding: 0 }}>
                <CardContent>
                  <div className={classes.number}>{step.nr}.</div>
                  <Typography variant='subheading' align='center'>
                    <ReactMarkdown source={Y`${step.description}`} />
                  </Typography>
                </CardContent>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    )
  }
}

HomePage = connect(mapStateToProps, mapDispatchToProps)(HomePage)
export default withStyles(styles)(HomePage)



// WEBPACK FOOTER //
// ./src/pages/home/index.js